import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Configuration Firebase fournie par la console
const firebaseConfig = {
  apiKey: "AIzaSyBRk-1GVZrGmj_htn1DMsdyx7mVcEPvgGQ",
  authDomain: "run-clubs.firebaseapp.com",
  projectId: "run-clubs",
  storageBucket: "run-clubs.firebasestorage.app",
  messagingSenderId: "564268731843",
  appId: "1:564268731843:web:481718e3a95a6270338176",
  measurementId: "G-MBPHLJRPRP"
};

// Initialisation Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Demande la permission et récupère le token FCM
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BOc4bRzWJu_c90I1gsgdAtEFky00mLSoKinOMOP7OV7y0FAt0l1LDGxblzYhWkHZMLz0hPjxZXW4tOPozpiefiw", // à compléter à l'étape suivante
      });
      console.log("✅ Token FCM :", token);
      // ✨ AJOUTER CETTE PARTIE ✨
      if (token) {
        // Enregistrer le token dans la BD
        const authToken = localStorage.getItem('token');
        
        try {
          const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

          const response = await fetch(`${API_URL}/users/register-fcm-token`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ fcmToken: token })
          });
          
          const data = await response.json();
          console.log('✅ Token enregistré dans la BD:', data);
        } catch (error) {
          console.error('❌ Erreur enregistrement token:', error);
          alert('❌ Erreur lors de l\'enregistrement du token');
        }
      }
      return token;
    } else {
      console.log("❌ Permission refusée");
      return null;
    }
  } catch (error) {
    console.error("Erreur lors de la récupération du token FCM :", error);
  }
};

// Écoute des messages reçus lorsque l’app est ouverte
onMessage(messaging, (payload) => {
  console.log("📩 Notification reçue en avant-plan :", payload);
  alert(payload.notification?.title || "Nouvelle notification !");
});
